<template>
	<div class="cruises">
		<back-to></back-to>
		<!-- 搜索 -->
		<section class="packageSearch_con">
			<div class="packageSearch_con-inp">
				<span class="packageSearch_con-inps">
					<input type="text" class="packageSearch_con__input" v-model="keyWord" placeholder="搜索产品名称"
						@keyup.13="onSearch" />
					<img class="packageSearch_con-icon" @click="onSearch"
						src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/index-seach.png" alt="">
				</span>
			</div>
			<div class="packageSearch_con-screen">
				<van-dropdown-menu active-color="#ff8a00" :class="dropdownmenu">
					<van-dropdown-item :title="sortIndex === '' ?'推荐顺序':sort[sortIndex].text"
						class="packageSearch_con-screen1" ref="sort">
						<h2 @click="sortIndex = '',$refs.sort.toggle()">推荐顺序</h2>
						<ul>
							<li v-for="(item,index) in sort" @click="sortIndex = index,$refs.sort.toggle(),onSearch()">
								<p>{{item.text}}</p>
								<img v-if="sortIndex == index"
									src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/seachlist-ok.png" alt="">
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item :title="cityIndex === '' ?'出发地':startCityList[cityIndex].value"
						class="packageSearch_con-screen2" ref="startCity">
						<h2 @click="cityChange">出发地</h2>
						<ul>
							<li v-for="(item,index) in startCityList"
								@click="cityIndex = index,$refs.startCity.toggle(),onSearch()"
								:style="cityIndex === index?'color:#ff8a00':''">
								<p>{{item.value}}</p>
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item :title="purposeIndex === '' ?'目的地': desCurren[purposeIndex].value"
						class="packageSearch_con-screen2" ref="purposeCity">
						<h2 @click="purposeChange">目的地</h2>
						<ul>
							<li v-for="(item,index) in desCurren"
								@click="purposeIndex = index,$refs.purposeCity.toggle(),onSearch()"
								:style="purposeIndex === index?'color:#ff8a00':''">
								<p>{{item.value}}</p>
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item title="全部筛选" ref="all">
						<div class="packageSearch_con-screen1">
							<h2>推荐顺序</h2>
							<ul>
								<li v-for="(item,index) in sort" @click="sortIndex = index">
									<p>{{item.text}}</p>
									<img v-if="sortIndex == index"
										src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/seachlist-ok.png" alt="">
								</li>
							</ul>
						</div>
						<div class="packageSearch_con-screen2">
							<h2>出发地</h2>
							<ul>
								<li v-for="(item,index) in startCityList" @click="cityIndex = index"
									:style="cityIndex === index?'color:#ff8a00':''">
									<p>{{item.value}}</p>
								</li>
							</ul>
						</div>
						<div class="packageSearch_con-screen2">
							<h2>目的地</h2>
							<ul>
								<li v-for="(item,index) in desCurren" @click="purposeIndex = index"
									:style="purposeIndex === index?'color:#ff8a00':''">
									<p>{{item.value}}</p>
								</li>
							</ul>
						</div>
						<div class="packageSearch_con_but">
							<span @click="reset">重置</span>
							<span @click="sure">确定</span>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
		</section>
		<section class="packageSearch_list">
			<van-list class="listItem" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				:immediate-check="false">
				<div class="packageSearch_lists-item">
					<div class="card-item-inner" v-for="(item, index) in data_product_array" :key="index"
						@click="item.price > 0 || item.refPrice ? nextTick(item.id) : ''">
						<span class="card-item-inner-first">
							<img class="card-item-inner_img" v-lazy="item.image" />
							<span class="bacSpace"></span>
							<span class="lm">
								<p class="lm-t">邮轮</p>
								<p class="lm-b">{{item.dep}}出发</p>
							</span>
						</span>
						<span class="card-item-inner-last">
							<h2 class="card-item-title">{{item.productName}}</h2>
							<span class='price-content' v-if="item.price > 0">
								<p class='size-26'>￥</p>
								<p class='size-30'>{{item.price}}</p>
								<p class='size-20'>起</p>
							</span>
							<span class="size-20 price-content gray" v-else>敬请期待</span>
						</span>
					</div>
				</div>
			</van-list>

		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'cruises',
		components: {
			BackTo
		},
		data() {
			return {
				loading: false,
				finished: false,
				page: 1,
				activeNames: ['1'],
				dropdownmenu: 'con-screen_menu',
				keyWord: '',
				sortIndex: '',
				cityIndex: '',
				purposeIndex: '',
				disArr: null,
				unfold: false,
				disArrIndex: 0,
				// 排序
				sort: [{
						text: '推荐',
						value: 1
					},
					{
						text: '销量优先',
						value: 2
					},
					{
						text: '价格由高到低',
						value: 4
					},
					{
						text: '价格由底到高',
						value: 3
					},
				],
				// 出发地
				startCityList: [],
				desCurren: [],
				data_product_array: []
			}
		},
		watch: {
			sortIndex() {
				this.shaixuan()
			},
			cityIndex() {
				this.shaixuan()
			},
			purposeIndex() {
				this.shaixuan()
			}

		},
		created() {

		},
		mounted() {
			this.getCity()
		},
		methods: {
			nextTick(id) {
				this.$router.push({
					path: '/cruiseDetail',
					query: {
						id: id
					}
				})
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				var data = {
					"pageIndex": this.page,
					"pageSize": 10,
					"keyword": this.keyWord,
					"depId": this.cityIndex !== '' ? Number(this.startCityList[this.cityIndex].key) : 0,
					"desId": this.purposeIndex !== '' ? Number(this.desCurren[this.purposeIndex].key) : 0,
					"orderBy": this.sortIndex !== '' ? Number(this.sort[this.sortIndex].value) : 1,
				}
				this.$post(
					this.$domainUrl + '/ShipApp/GetShipList', data
				).then(res => {
					if (res == undefined) {
						this.finished = true;
					} else {
						if (e) {
							this.data_product_array = res.data
						} else {
							this.data_product_array = this.data_product_array.concat(res.data)
						}
						if (res.data.length < 10) {
							this.finished = true;
						}
					}

				})
			},
			shaixuan() {
				if (this.sortIndex !== '' && this.cityIndex === '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex !== '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc2 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex === '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc3 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex !== '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc2 menuAc3 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex !== '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc2 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex === '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc3 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex !== '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc2 menuAc3 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex === '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu'
				}
			},
			onSearch() {
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			cityChange() {
				this.cityIndex = ''
				this.$refs.startCity.toggle()
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			purposeChange() {
				this.disArr = null
				this.purposeIndex = ''
				this.$refs.purposeCity.toggle()
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			reset() {
				this.keyWord = ''
				this.sortIndex = ''
				this.cityIndex = ''
				this.purposeIndex = ''
				this.disArr = null
				this.$refs.all.toggle()
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			sure() {
				this.$refs.all.toggle()
				this.onSearch()
			},
			// 邮轮游
			getCity() {
				var data = {}
				this.$get(
					this.$domainUrl + '/ShipApp/GetDeparture', data
				).then(res => {
					this.startCityList = res.data.dep
					this.desCurren = res.data.des
					this.getList()
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style scoped>
	.packageSearch_con {
		width: 100%;
		background: #fff;
		top: @nav-bar-height;
		position: fixed;
		z-index: 99;
	}

	.packageSearch_con-inp {
		width: 100%;
		height: 80px;
		padding: 0 30px 20px;
		box-sizing: border-box;
	}

	.packageSearch_con-inps {
		border: 1px #ff6d00 solid;
		height: 70px;
		border-radius: 36px;
		display: flex;
		padding: 0 36px;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}

	.packageSearch_con-icon {
		width: 28px;
		height: 28px;
	}

	.packageSearch_con__input {
		font-size: 26px;
		flex: 1;
		border: 0;
	}

	.packageSearch_con-screen {
		width: 100%;
	}

	.con-screen_menu {
		color: #666;
	}

	.menuAc .van-dropdown-menu__item:nth-child(1) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc .van-dropdown-menu__item:nth-child(1) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc2 .van-dropdown-menu__item:nth-child(2) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc2 .van-dropdown-menu__item:nth-child(2) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc3 .van-dropdown-menu__item:nth-child(3) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc3 .van-dropdown-menu__item:nth-child(3) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc4 .van-dropdown-menu__item:nth-child(4) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc4 .van-dropdown-menu__item:nth-child(4) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.con-screen_menu .van-dropdown-menu__title {
		font-size: 28px;
	}

	.packageSearch_con-screen .van-dropdown-menu__bar {
		box-shadow: none;
		height: 70px
	}

	.packageSearch_con-screen1 li {
		height: 80px;
		padding: 0 30px;
		border-bottom: 1px solid #efefef;
		font-size: 28px;
		color: #000;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.packageSearch_con-screen1 img {
		width: 23px;
		height: 19px;
	}

	.packageSearch_con-screen2 {
		margin-top: 10px;
	}

	.packageSearch_con-screen2 ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 100%;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.packageSearch_con-screen2 li {
		height: 66px;
		line-height: 66px;
		text-align: center;
		width: 216px;
		border-radius: 10px;
		background: #efefef;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-sizing: border-box;
		margin-bottom: 20px;
		color: #000;
	}

	.packageSearch_con-screen2 li:last-child:nth-child(3n-1) {
		margin-right: 237px
	}

	.packageSearch_con-screen1 h2,
	.packageSearch_con-screen2 h2 {
		height: 60px;
		line-height: 60px;
		color: #000;
		padding: 0 30px;
		font-weight: bold;
		font-size: 28px;
	}

	.packageSearch_con_but {
		width: 100%;
		box-sizing: border-box;
		padding: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.packageSearch_con_but span:first-child {
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.packageSearch_con_but span:last-child {
		background: #ff8a00;
		color: #fff;
	}

	.packageSearch_con_but span {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 66px;
		width: 300px;
		font-size: 30px;
		border-radius: 200px;
		line-height: 64px;
	}

	.packageSearch_list {
		margin-top: 155px;
	}

	.packageSearch_lists {
		margin-top: 240px;
	}

	.packageSearch_con-ollapse {
		width: 100%;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.con-ollapse {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		border-top: 1px solid #efefef;
		padding-top: 20px;
		height: 60px;
		overflow: hidden;
		position: relative;
	}

	.con-ollapse-c {
		height: auto;
	}

	.con-ollapse1 {
		width: 100px;
		font-size: 28px;
	}

	.con-ollapse2 {
		width: 560px;
		flex-wrap: wrap;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.con-ollapse2 p {
		margin-left: 20px;
		height: 43px;
		line-height: 43px;
		padding: 0 20px;
		background: #f7f7f7;
		border-radius: 200px;
		font-size: 28px;
		color: #333;
		margin-bottom: 20px;
	}

	.con-ollapse2a {
		background: #ff8a00 !important;
		color: #fff !important;
	}

	.con-ollapse2 font {
		position: absolute;
		bottom: 40px;
		right: 0;
		width: 20px;
	}

	.con-ollapse2 img {
		height: 10px;
		width: 17px;
		margin-left: auto;
	}

	.listItem {
		width: 100%;
		padding: 26px;
		box-sizing: border-box;
	}

	.packageSearch_lists-item {
		width: 100%;
		/* padding: 26px; */
		/* box-sizing: border-box; */
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}

	.card-item-inner {
		width: 336px;
		background-color: #fff;
		border-radius: 20px;
		margin-bottom: 16px;
		position: relative;
		height: 496px;
	}

	.card-item-inner-first {
		width: 100%;
		height: 324px;
		position: relative;
		display: flex;
	}

	.card-item-inner_img {
		width: 100%;
		height: 324px;
		border-radius: 20px 20px 0 0;
		object-fit: cover;
	}

	.bacSpace {
		width: 100%;
		height: 324px;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.15);
		border-radius: 20px 20px 0 0;
		z-index: 2;
	}

	.lm {
		position: absolute;
		top: 10px;
		left: 15px;
		color: #fff;
		font-size: 24px;
		z-index: 3;
	}

	.lm-t {
		display: inline;
		padding-bottom: 8px;
		border-bottom: 1px solid #fff;
	}

	.lm-b {
		margin-top: 10px;
		font-size: 22px;
	}

	.card-item-inner-last {
		width: 100%;
		height: 172px;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.card-item-title {
		font-size: 28px;
		line-height: 35px;
		font-family: PingFangSC-Semibold, sans-serif;
		color: #333;
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.price-content {
		color: #ff8a00;
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
	}

	.size-30 {
		font-size: 32px;
		margin-left: 4px;
		font-weight: bold;
	}

	.size-20 {
		font-size: 20px;
		margin-left: 6px;
		margin-bottom: 3px;
	}

	.size-26 {
		font-size: 26px;
	}

	.gray {
		color: #ccc;
	}

	.van-list__finished-text {
		width: 100%;
	}

	.loading {
		width: 300px;
		height: 300px;
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
	}

	.self-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 117px;
		height: 117px;
		z-index: 3;
	}

	.lm-y {
		font-weight: 400;
		line-height: 36px;
		height: 36px;
		color: #FFFFFF;
		background-color: rgba(0, 0, 0, 0.3);
		border-radius: 18px;
		padding-left: 18px;
		padding-right: 18px;
	}
</style>
